import React from 'react';
import { Link } from 'react-router-dom';

import LogoPrimary from '@/assets/images/black-for-restaurants.webp';

export interface LogoProps {
  redirectUrl?: string;
}

export const Logo = ({ redirectUrl = '/' }: LogoProps) => {
  const srcLogo = LogoPrimary;

  return (
    <Link to={redirectUrl}>
      <img width={50} height={30} src={srcLogo} alt="logo of mrh" className="hidden md:block my-0" />
      <img width={30} height={20} src={srcLogo} alt="logo of mrh" className="md:hidden block w-44 h-full" />
    </Link>
  );
};
